import * as React from 'react'

import { Button, Grid, Typography } from '@material-ui/core'
import Form from './form'

import Logo from 'assets/img/logo.svg'

import { PopupLoader } from 'components'

import './style.scss'

interface IProps {
  doReset: () => void
  loading: boolean
}

const Content: React.FC<IProps> = ({ loading, doReset }: IProps) => {
  return (
    <Grid
      container={true}
      direction="column"
      justify="flex-start"
      alignItems="center"
      className="reset-password-page page-min-content"
    >
      <header className="header">
        <img className="logo" src={Logo} />
      </header>
      <div className="reset-password-page-content">
        <div className="heading">
          <Typography className="reset-password-page-title">
            Reset Password
          </Typography>
        </div>
        <div className="form-container">
          <Form />
        </div>
        <div className="reset-wrapper">
          <Button
            className="black-btn reset-button"
            color="primary"
            onClick={doReset}
          >
            Reset
          </Button>
        </div>
      </div>

      <PopupLoader active={loading} />
    </Grid>
  )
}

export default Content



// WEBPACK FOOTER //
// ./src/pages/EmailHandler/ResetPassword/content.tsx